module.exports = __webpack_public_path__ + "static/rotated-23c0fe5fefd760a7796bb1aaca7f9b2d.png";